/*
 * Created: 2019-05-20 16:54:05
 * Author : zc
 * Email : 591074801@qq.com
 * -----
 * Description: 
 */
<template>
  <!-- 修改手机号 -->
  <v-dialog v-model="showDialog" :width="dialogWidth" persistent transition="">
    <div style="background-color:white;">
      <div class="primary">
        <v-layout>
          <v-flex align-self-center>
            <div class="modaltitle primary" style="color:white; margin:10px;">{{ dialogTitle }}</div>
          </v-flex>
          <v-flex style="text-align:right;">
            <v-btn icon flat color="white" @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div style="padding:10px;">
        <v-icon v-if="iconType === 'warning'" style="color:#fb8c00;font-size:35px;margin-right:10px;">warning</v-icon>
        <v-icon v-if="iconType === 'error'" style="color:#f10d0db5;font-size:35px;margin-right:10px;">warning</v-icon>
        <v-icon v-if="iconType === 'info'" style="color:red;font-size:35px;margin-right:10px;">info</v-icon>
        <slot name="content"></slot>
      </div>
      <!-- 底部按钮 :loading="loading"-->
      <div style="text-align:center;">
        <div v-show="showButton">
          <v-btn style="margin-bottom:10px" @click="close">
            取消
          </v-btn>
          <!-- clickthrottle：true 需要防止连续点击 default:true -->
          <v-btn
            v-if="clickthrottle"
            v-show="!hideSubmitButton"
            style="margin-bottom:10px;margin-left:30px"
            :color="submitColor"
            v-clickthrottle="{ handle: submit, delay: 3000 }"
            :disabled="!formValid"
            :loading="loading"
          >
            {{ submitTitle }}
          </v-btn>
          <!-- 不需要防止连续点击 -->
          <v-btn v-else v-show="!hideSubmitButton" style="margin-bottom:10px;margin-left:30px" :color="submitColor" @click="submit" :disabled="!formValid" :loading="loading">
            {{ submitTitle }}
          </v-btn>
        </div>
        <div v-show="showClose">
          <v-btn style="margin-bottom:10px" @click="close">
            关闭
          </v-btn>
        </div>
      </div>
    </div>
    <!-- <v-card>
      <v-card-title class="headline primary" style="color:white;" primary-title>
        {{ dialogTitle }}
      </v-card-title>

      <v-container>
        <v-icon v-if="iconType === 'warning'" style="color:#fb8c00;font-size:35px;margin-right:10px;">warning</v-icon>
        <v-icon v-if="iconType === 'error'" style="color:#f10d0db5;font-size:35px;margin-right:10px;">warning</v-icon>
        <v-icon v-if="iconType === 'info'" style="color:red;font-size:35px;margin-right:10px;">info</v-icon>
        <slot name="content"></slot>
      </v-container>

      <v-card-actions v-show="showButton">
        <v-spacer></v-spacer>
        <v-btn style="margin-bottom:10px" @click="close" :loading="loading">
          取消
        </v-btn>
        <v-btn v-show="!hideSubmitButton" style="margin-bottom:10px;margin-left:30px" :color="submitColor" @click="submit" :disabled="!formValid" :loading="loading">
          {{ submitTitle }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card-actions v-show="showClose">
        <v-spacer></v-spacer>
        <v-btn style="margin-bottom:10px" @click="close">
          关闭
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
     -->
  </v-dialog>
</template>

<script>
export default {
  props: {
    showDialog: Boolean,
    dialogTitle: {
      type: String,
      default: '提示'
    },
    dialogWidth: {
      type: [Number, String],
      default: 500
    },
    formValid: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    showButton: {
      type: Boolean,
      default: true
    },
    showClose: Boolean,
    submitTitle: {
      type: String,
      default: '确定'
    },
    submitColor: {
      type: String,
      default: 'primary'
    },
    hideSubmitButton: Boolean,
    clickthrottle: {
      type: Boolean,
      default: true
    },
    iconType: String
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      this.$emit('submit', this.submit.stop);
    }
  }

}
</script>

<!-- <script lang="ts">
    import { Vue, Component, Prop } from 'vue-property-decorator';
    
    @Component
    export default class AMSDialog extends Vue {
      @Prop({ default: false }) showDialog!: Boolean;
      @Prop({ default: '提示' }) dialogTitle!: string;
      @Prop({ default: 500 }) dialogWidth!: number;
      @Prop({ default: true }) formValid?: boolean;
      @Prop({ default: false }) loading?: boolean;
      /**是否显示按钮 */
      @Prop({ default: true }) showButton!: Boolean;
      /**是否显示关闭按钮 */
      @Prop({ default: false }) showClose!: Boolean;
      /**确定按钮的文本 */
      @Prop({ default: '确定' }) submitTitle!: string;
      /**确定按钮的颜色 */
      @Prop({ default: 'primary' }) submitColor!: string;
      /**是否显示确定按钮 */
      @Prop({ default: false }) hideSubmitButton!: Boolean;
      @Prop({ default: true }) clickthrottle!: Boolean;
    
      // icon图标
      @Prop() iconType!: string;
      /**点击了取消按钮 */
      close() {
        this.$emit('close');
      }
      /**点击了确认按钮 */
      submit() {
        this.$emit('submit', this.submit.stop);
      }
    }
    </script> -->

<style scoped>
.v-card__title {
  padding-top: 9px;
  padding-bottom: 9px;
  background-color: transparent;
}
.modaltitle {
  font-size: 22px !important;
}
</style>

<style>
div[class='v-input v-input--selection-controls v-input--checkbox v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light'] i {
  color: #82b1ff !important;
}
</style>
